import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
import { Table } from 'antd'
const { WizSpin, WizButton, WizCard, WizModal } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

import CounselingHeader from '../../header'

const findParamRecord = (history) => {
    let record = {}
    let key = ''
    if (history.location && history.location.pathname === '/integrationCounseling/manager/antecedentIntervention/salesOpening') {
        key = 'salesOpening'
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set(key, record)
        } else {
            record = Session.get(key) || {}
        }
    }
    if (history.location && history.location.pathname === '/integrationCounseling/manager/antecedentIntervention/afterOpening') {
        key = 'afterOpening'
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set(key, record)
        } else {
            record = Session.get(key) || {}
        }
    }
    return { record, key }
}

class SalesOpening extends WizContainer {

    componentName = 'SalesOpening'

    constructor(props) {
        super(props)
        let { record, key } = findParamRecord(props.history)
        this.state = {
            record,
            key
        }
    }

    _componentDidMount() {
        this._list()
    }

    _list = () => {
        const { processContentId } = this.state.record
        this.doAction({
            path: 'counselingProcess/salesOpening',
            payload: {
                key: 'salesOpening@' + processContentId,
                apiParams: {
                    tutorContentId: processContentId
                }
            }
        })
    }

    _onBtn = (type) => {
        const { record, key } = this.state
        const { processContentId } = record
        let path
        switch (type) {
            case 'look':
                path = `/integrationCounseling/manager/antecedentIntervention/${key}/look`
                break
            case 'audit':
                path = `/integrationCounseling/manager/antecedentIntervention/${key}/examine`
                break
        }
        this.jumpPage('push', path, { processContentId })
    }

    _onConfirm = () => {
        const { processContentId } = this.state.record
        WizModal.confirm({
            title: '注意',
            content: '是否确认进行达标确认操作？',
            onOk: () => {
                this.doAction({
                    path: 'counselingProcess/confirmSalesOpening',
                    payload: {
                        key: 'confirmSalesOpening@' + processContentId,
                        apiParams: {
                            tutorContentId: processContentId
                        }
                    }
                })
            },
            onCancel() {
            }
        })
    }

    propsAndStateOnChange = {
        confirm: this._confirmOnChange.bind(this)
    }

    _confirmOnChange(nextProps, nextState) {
        if (nextProps.confirm.code === 1) {
            wizNotice.success('操作成功')
            this.jumpPage('goBack')
        } else {
            wizNotice.error(nextProps.confirm.msg)
        }
    }

    render() {
        let { record, key } = this.state
        let { processContentState } = record
        let { list, counselingProcessLoading } = this.props
        let data = list.data && list.data.length ? list.data[0] || {} : {}
        let columns = [{
            title: '执行内容',
            name: 'content',
            dataIndex: 'content',
        }, {
            title: '提交时间',
            name: 'submitTime',
            dataIndex: 'submitTime'
        }, {
            title: '审核时间',
            name: 'auditTime',
            dataIndex: 'auditTime'
        }, {
            title: '审核结果',
            name: 'auditState',
            dataIndex: 'auditState',
            render: (v) => {
                switch (v) {
                    case 0:
                        return '不合格'
                    case 1:
                        return '合格'
                    default:
                        return ''
                }
            }
        }, {
            title: '审核意见',
            name: 'comment',
            dataIndex: 'comment'
        }, {
            title: '操作',
            name: 'operation',
            dataIndex: 'operation',
            align: 'center',
            width: 220,
            render: (v, r, i) => {
                let { submitTime, auditTime } = r
                let disabled = !submitTime || processContentState !== 0
                return (
                    <WizButton.Group>
                        <WizButton type='link' disabled={!submitTime} onClick={() => this._onBtn('look')}>
                            {'查看'}
                        </WizButton>
                        <WizButton type='link' disabled={disabled} onClick={() => this._onBtn('audit')}>
                            {!auditTime ? '审核' : '复审'}
                        </WizButton>
                    </WizButton.Group>
                )
            }
        }]

        let tableProps = {
            columns,
            dataSource: list.data || [],
            pagination: false,
            bordered: true
        }

        return (
            <WizSpin spinning={counselingProcessLoading} >
                <CounselingHeader record={record} />
                <WizCard title={`${key === 'salesOpening' ? '销售' : '售后'}系统开通`}>
                    <WizButton
                        type='primary'
                        style={{ marginBottom: 15, width: 90 }}
                        disabled={processContentState !== 0 || data.auditState !== 1}
                        onClick={() => this._onConfirm()}>
                        {'达标确认'}
                    </WizButton>
                    <Table {...tableProps} />
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { record } = findParamRecord(ownProps.history)
    const { processContentId } = record
    const list = modelUtils.getModelEntity(counselingProcess, 'salesOpening@' + processContentId)
    const confirm = modelUtils.getModelEntity(counselingProcess, 'confirmSalesOpening@' + processContentId)
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        list,
        confirm,
        ...loading
    }
}

export default connect(mapStateToProps)(SalesOpening)


